import {Component, OnInit} from '@angular/core';
import {DataService, DatasetBannerModel, DatasetBannerView} from 'src/app/services/data.service';
import {SessionService, UserType} from 'src/app/services/session.service';

@Component({
  selector: 'app-vendor-prize',
  templateUrl: './prize.component.html',
  styleUrls: ['./prize.component.scss']
})
export class PrizeComponent implements OnInit {

  enterpriseUser = null;

  constructor(private sessionService: SessionService,
              public dataservice: DataService,
              public datasetBannerModel: DatasetBannerModel) {
  }

  ngOnInit() {
    if (this.dataservice.data.accountId === this.sessionService.getUser().roleId) {
      this.enterpriseUser = true;
    } else {
      this.enterpriseUser = false;
    }
    this.datasetBannerModel.setBannerView(DatasetBannerView.PrizeView);
  }
}
